import React from 'react';
import { Collapse } from '@mui/material';
import Banner from 'components/Banner';
import { useTranslation } from 'services/localization';
import * as TranslationsActions from 'actions/TranslationsActions';
import * as TranslationsSelectors from 'selectors/TranslationsSelectors';
import { useDispatch, useSelector } from 'react-redux';

const TranslationErrorBanner = (props: { hidden?: boolean }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isSaving = useSelector(TranslationsSelectors.isSaving);
	const isError = useSelector(TranslationsSelectors.isError);

	return (
		<Collapse in={!props.hidden && isError}>
			<Banner
				variant="danger"
				title={t('account.languages.translations.errorTitle', 'Save failed')}
				description={t(
					'account.languages.translations.errorDescription',
					'Some fields were not saved successfully',
				)}
				button={{
					text: t('common:actions.retry'),
					onClick: () => dispatch(TranslationsActions.retryAllFailedSaves),
					loading: isSaving,
				}}
			/>
		</Collapse>
	);
};

export default TranslationErrorBanner;
